<div id="site-wrapper" class="page-wrap d-flex">
    <app-sidebar (togglingMobileMenu)="onMobileMenuToggle($event)" [ngClass]="{'sb-sidenav-toggled': showMobileNav}" *ngIf="!hideSidebar"></app-sidebar>
    <section class="page-container">
        <app-header (togglingMobileMenu)="onMobileMenuToggle($event)" *ngIf="!hideHeader"></app-header>
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <!-- <breadcrumb></breadcrumb> -->
        <!-- ============================================================== -->
        <!-- Start Page Content -->
        <!-- ============================================================== -->
        <div *ngIf="impersonating" class="impersonateBanner">
            <div class="d-flex align-items-center px-4 h-100">
                <h3 class="flex-grow-1 mb-0">
                    <i class="fas fa-theater-masks"></i>
                    <span>Impersonating: {{impersonatedContactName}}</span>
                </h3>
                <a class="ml-auto btn btn-outline-dark fw-bold" (click)="endImpersonation('/admin-portal/chamber/super-admin-management')" id="endImpersonate">
                    <i class="far fa-stop-circle"></i> Stop Impersonating
                </a>
            </div>
        </div>
        <!-- <ams-action-items></ams-action-items> -->
        <router-outlet></router-outlet>
        <!-- ============================================================== -->
        <!-- End Start Page Content -->
        <!-- ============================================================== -->
    </section>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->

  </div>